import Reveal from "../Reveal";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onContactOpen }) {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="py-28 md:py-40 border-t border-[#E2DCD0] bg-[#F9F6F0]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
            06 — Let's Begin
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2
            data-testid="final-cta-headline"
            className="font-display font-light tracking-tighter leading-[0.95] text-[#0F172A] text-5xl md:text-7xl lg:text-8xl"
          >
            What <span className="italic">stories</span> <br />
            are hiding inside <br /> your business?
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-lg md:text-xl text-[#475569] font-light">
            Let's uncover them together.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
            <button
              data-testid="final-cta-button"
              onClick={() => onContactOpen()}
              className="group inline-flex items-center gap-3 bg-[#C86A53] hover:bg-[#A65541] text-[#F9F6F0] px-8 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-all duration-300"
            >
              Let's Talk About Growth
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
